module.exports = __webpack_public_path__ + "img/model_1000.27bf2f1a.jpg";